import { Component, output, signal } from '@angular/core';
import { Driver } from '../../../interfaces/driver';

@Component({
  selector: 'app-find-driver-tooltip',
  standalone: true,
  imports: [],
  templateUrl: './find-driver-tooltip.component.html',
  styleUrl: './find-driver-tooltip.component.scss',
})
export class FindDriverTooltipComponent {
  assign = output<Driver>();
  hide = output<Driver>();
  closed = output<void>();
  driver = signal<Driver | null>(null);
}
